Date.prototype.Format = function (fmt) { //格式化时间
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}





// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import vueResource from 'vue-resource'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/css/reset.css'
import '../src/assets/css/global.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import comFun from './assets/js/common'
Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI)
// Vue.use(vueResource)

//路由跳转增加钩子 判断是否需要权限
router.beforeEach((to, from, next) => {
  if (to.meta.roleId) {  // 判断该路由是否需要登录权限
    if (to.meta.roleId.indexOf(localStorage.getItem('roleId')*1)!=-1) {  // 判断roleId是否有权限进行此操作
      next();
    }
    else {
      if(typeof vm==="undefined"){
        next({
          path:"/"
        })
        return false;
      };
      if(localStorage.getItem('token')){
        vm.$alert('您没有权限访问此页面', '警告', {
          type: 'waring',
          confirmButtonText: '确定',
          callback: action => {
            next({
              path:"/",
            })
          }
        });
      }else{
        vm.$alert('您还未登录，请先登录', '错误', {
          type: 'error',
          confirmButtonText: '确定',
          callback: action => {
            next({
              path: '/login',
              query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
          }
        });
      }

    }
  }
  else {
    next();
  }
})



Vue.config.productionTip = false
axios.defaults.timeout = 15000;                        //响应时间
axios.defaults.baseURL = 'https://speedskating.org.cn:8013';   //配置接口地址
// axios.defaults.baseURL = 'http://192.168.27.75:5464';   //配置接口地址

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {

  config.headers["Content-Type"]="application/x-www-form-urlencoded; charset=UTF-8";
  config.headers["Accept"]="/";
  /*
  * 增加data参数转换，满足Content-Type为上面的情况
  * 否则发送过去的form-data为字符串*/
  config.transformRequest=[function (data) {
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
  }];
  var token = localStorage.getItem('token');
  if(token){
    config.headers.token=localStorage.getItem('token');
    config.headers.userId=localStorage.getItem('userId');
    config.headers.roleId=localStorage.getItem('roleId');
    config.headers.userName=encodeURIComponent(localStorage.getItem('userName'));
  }
  // if(config.method  === 'post'){
  //   config.data = qs.stringify(config.data);
  // }
  return config;
},(error) =>{
  return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
  // 对响应数据做些事
  if(res.status!=200){
    console.log(res);
  }
  if(res.data.code!=200){
    vm.$message.error("网络层错误");
  }
  if(res.data.resultValue.msg.errCode!=0){
    switch(res.data.resultValue.msg.errCode){ //处理业务层错误
      case 1001:
        console.error(res.data.resultValue.msg.message);
        break;
      case 2001:
        vm.$message.error(res.data.resultValue.msg.message);
        router.replace("/login");
        break;
      case 2002:
        router.replace("/login");
        break;
      case 2003:
        vm.$message.error("没有权限访问此页面");
        router.go(-1);
        break;
      case 2023:
        vm.$alert(res.data.resultValue.msg.message, {
          type: 'error',
          confirmButtonText: '确定',
        });
        break;
      case 5001:
        console.error(res.data.resultValue.msg.message);
        break;
      default:
        vm.$message.error(res.data.resultValue.msg.message);

    }
    return Promise.reject(res.data.resultValue.msg);

  }
  return res;
}, (error) => {
  console.log(error)
  return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    axios.get(url, {params: param})
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


Vue.prototype.$http = axios
Vue.prototype.comFun=comFun;
Vue.use(VueAxios, axios)

/* eslint-disable no-new */
window.vm=new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // watch:{
  //   $route(to,from){
  //     window.scrollTo(0,0);
  //   }
  // },
})



// WEBPACK FOOTER //
// ./src/main.js